export const studies = [
  {
    date: "2023 - 2025",
    degree: "Bachelor of Arts in Graphic Design",
    institution: "San Jose State University",
    url: "https://www.sjsu.edu/",
  },
];
